<template>
  <Modal
    id="deliveryReport-modal"
    :isOpen.sync="isModalOpen"
    @cancel="resetModal"
    :buttonLabelClose="$t('global.close')"
    :header="$t('deliveryReport.label')"
  >
    <CDPSelector class="column" v-model="selectedCDP" required />
    <Field
      class="input-datepicker"
      v-model="selectedDate"
      :label="$t('global.date')"
      icon-right="calendar-blank"
      readonly
    />
    <DatePicker
      v-model="selectedDate"
      :maxDate="maxDate"
      :minDate="minDate"
      responseFormat="MM/DD/YYYY"
      inline
    />
    <template #buttons>
      <Button
        :label="$t('global.downloadReport')"
        @click="handleDownloadReport"
        type="is-primary"
        :loading="loading"
        :disabled="!selectedCDP"
      />
    </template>
  </Modal>
</template>

<script>
import { toast } from '@/utils/dialog';
import { Modal, DatePicker, Button, Field } from '@/components';
import CDPSelector from '@/components/CDP/CDPSelector.vue';

export default {
  components: {
    Modal,
    DatePicker,
    Button,
    Field,
    CDPSelector
  },
  data() {
    return {
      loading: false,
      isModalOpen: this.isOpen,
      selectedCDP: null,
      selectedDate: this.$moment(new Date()).format('MM/DD/YYYY')
    };
  },
  computed: {
    maxDate() {
      return this.$moment().toDate();
    },
    minDate() {
      return this.$moment('2022-1-1', 'Y-M-D').subtract(1, 'days').toDate();
    }
  },
  methods: {
    async handleDownloadReport() {
      this.loading = true;
      try {
        await this.Api.post(`delivery_manifest/delivery_events/reports/pdf`, {
          date: this.$moment(this.selectedDate, 'MM/DD/YYYY').format('YYYY-MM-DD'),
          close_door_pharmacy_id: this.selectedCDP
        });
        toast('success', this.$t('deliveryReport.successMessage'), 3000);
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
    },
    resetModal() {
      this.selectedDate = this.$moment(new Date()).format('MM/DD/YYYY');
      this.isModalOpen = false;
    }
  },
  watch: {
    isOpen(value) {
      this.isModalOpen = value;
    },
    isModalOpen(value) {
      this.$emit('update:isOpen', value);
      if (!value) this.resetModal();
    }
  },
  props: {
    isOpen: { type: Boolean, default: false }
  }
};
</script>
<style lang="sass" scoped>
#deliveryReport-modal
  ::v-deep
    .modal-content-container
      .slot
        display: flex
        flex-direction: column
        justify-content: center
        align-items: center
        overflow: hidden
        .input-datepicker
          min-width: 304px
</style>
<style lang="sass">
.dark
    #deliveryReport-modal
      .modal-content-container
        .slot
          .datepicker-body
            .is-selectable
              color: $white
              &:hover
                background-color: $blue-500
            .is-unselectable
              color: $disable-dark
</style>
